import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Row, Stack } from 'react-bootstrap';
import { LineOfCreditOffer } from 'states/initialState';
import { DecimalFormat, IntegerFormat, MoneyFormat } from '../Common/TextFormat';

interface ModalProps {
  deal: LineOfCreditOffer;
  email: string;
}

const LineOfCredit = ({ deal, email }: ModalProps) => {
  const intl = useIntl();
  return (
    <Row xs={1} md={2} className="py-1 gy-3 gx-5 fs-5">
      <Stack direction="horizontal">
        <FormattedMessage id="confirmation.product" />
        <span className="text-secondary ms-auto">
          <FormattedMessage id="confirmation.loc" />
        </span>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="lineOfCredit.paymentFreq" />
        <span className="ms-auto text-secondary">
          {deal.paymentFrequency[0]}
        </span>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="lineOfCredit.creditLimit" />
        <MoneyFormat value={deal.lineAmount} cents={false} className="ms-auto"/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="lineOfCredit.numberOfPayments" />
        <IntegerFormat value={deal.numberOfPayments} className="ms-auto"/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="lineOfCredit.term" />
        <IntegerFormat value={deal.term} className="ms-auto"          
          suffix={intl.formatMessage({ id: 'confirmation.months' })}
        />
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="lineOfCredit.totalCost" />
        <MoneyFormat value={deal.totalDrawCost} className="ms-auto"/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="lineOfCredit.apr" />
        <DecimalFormat value={deal.apr} suffix="%" className="ms-auto"/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="lineOfCredit.totalPayback" />
        <MoneyFormat value={deal.totalAmountPaidBack} className="ms-auto"/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="lineOfCredit.eqCoD" />
        <DecimalFormat value={deal.equivalentCoD} decimalScale={3} className="ms-auto"/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="common.email" />
        <a
          href={`mailto: ${email}`}
          className="fw-600 ms-auto ps-2 text-break text-end"
        >
          {email}
        </a>
      </Stack>
    </Row>
  );
};

export default LineOfCredit;
